/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-23 20:23:54 */

const Keys = {
  adult: 'adult',
  adult_other: 'adult_other',
  child: 'child',
  child_other: 'child_other',
  infant: 'infant',
  infant_other: 'infant_other',
  button: 'button',
  traveler: 'traveler',
  traveler_other: 'traveler_other',
  guest: 'guest',
  guest_other: 'guest_other',
  room: 'room',
  room_other: 'room_other',
  addRoom: 'addRoom',
  travellerAgeInfo: 'travellerAgeInfo',
  age: 'age',
  ageCapitalized: 'ageCapitalized',
  validationErrorMessage: 'validationErrorMessage',
  childAgeErrorMessage: 'childAgeErrorMessage',
  childAgeRange: 'childAgeRange',
  infantAgeRange: 'infantAgeRange',
  adultAgeRange: 'adultAgeRange',
  pleaseSelect: 'pleaseSelect',
  updateSearch: 'updateSearch',
  occupancyErrorMessage: 'occupancyErrorMessage'
}; export default Keys;